import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { settingsKeys } from "@/shared/api/settings";

import { createOrg } from "./api/org";
import { Step, NextButton, StepError, OnboardingShell, inputCls } from "./OnboardingFrame";
import { useSubmit } from "./hooks/useSubmit";

/* Shown when `settings.org` is null — the caller has no active membership,
   whether because they were removed from their org and never made another or
   because their only tie to one is an invite they have not accepted. Either
   way there is no workspace for the wizard to set up. One question, then the
   settings query refetches and the app carries on down the normal boot path. */
export default function CreateOrg() {
  const qc = useQueryClient();
  const [name, setName] = useState("");
  const { pending, error, submit } = useSubmit();
  const ok = name.trim().length > 0;

  const go = () =>
    ok &&
    submit(async () => {
      await createOrg({ name: name.trim() });
      await qc.invalidateQueries({ queryKey: settingsKeys.all });
    });

  return (
    <OnboardingShell>
      <Step
        index={0}
        eyebrow="Workspace"
        title="Name your workspace"
        subtitle="Everything you build — agents, traces, teammates — lives inside it."
        footer={
          <div>
            <NextButton disabled={!ok || pending} onClick={go}>
              {pending ? "Creating…" : "Create workspace"}
            </NextButton>
            <StepError message={error} />
          </div>
        }
      >
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && go()}
          placeholder="Studio Co"
          className={inputCls}
        />
      </Step>
    </OnboardingShell>
  );
}
